import diContainer from "true-di";

import { IStorageService, ItemStorage } from "@src/interfaces";
import { PriceItem } from "@domain/price";
import { BillingInfo } from "@src/domain/billingInfo";

type StorageServiceDeps = {
	priceItem: ItemStorage<PriceItem>;
	billingInfo: ItemStorage<BillingInfo>;
	token: ItemStorage<string>;
	refreshToken: ItemStorage<string>;
};

const StorageService = (parent: StorageServiceDeps) =>
	diContainer<IStorageService>({
		priceItem: () => parent.priceItem,
		billingInfo: () => parent.billingInfo,
		token: () => parent.token,
		refreshToken: () => parent.refreshToken,

		setTokens:
			(self) =>
			({ token, refreshToken }: { token: string; refreshToken: string }) => {
				self.token.write(token);
				self.refreshToken.write(refreshToken);
			},

		clearAll: (self) => () => {
			self.priceItem.clear();
			self.billingInfo.clear();
			self.token.clear();
			self.refreshToken.clear();
		},

		clearPurchaseData: (self) => () => {
			self.priceItem.clear();
			self.billingInfo.clear();
		},
	});

export default StorageService;
